export default {"src":"/_next/static/media/alias-to-mask-icon.2db46cf4.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};